<section class="agpr-newDistribution">
    <div class="agpr-newDistribution-container">
        <div class="agpr-newDistribution-content">
            <div class="agpr-newDistribution-header">
                {{ 'Discover.distribution.newDistribution.header' | localize }}
            </div>
            <agpr-tabs
                class="agpr-newDistributionTabs"
                [selectedTabIndex]="selectedTabIndex"
                (selectedTabIndexChange)="changeTabs($event)"
                [tabsHeadingLevel]="4"
            >
                <agpr-tab
                    [id]="id + '_templateTab'"
                    [icon]="'fa-kit-duotone fa-agpr-template'"
                    [heading]="'Discover.distribution.newDistribution.agilityTemplates'"
                >
                    <div
                        class="agpr-newDistribution-templateListContainer"
                        role="listbox"
                        [attr.aria-label]=" 'Discover.distribution.newDistribution.template' | localize"
                    >
                        <agpr-template-card
                            *ngFor="let template of agilityTemplates"
                            [template]="template"
                            (click)="selectTemplate(template, $event)"
                            (keydown)="selectTemplate(template, $event)"
                            [imagePosition]="template.id === distributionTemplatesEnum.DISTRIBUTION_TEMPLATE_MINIMALIST ? 'center' : 'top'"
                        >
                        </agpr-template-card>
                    </div>
                </agpr-tab>
                <agpr-tab
                    noScrollPanelContent
                    [id]="id + '_savedTemplates'"
                    [icon]="'fa-regular fa-duotone fa-floppy-disk'"
                    [heading]="'Discover.distribution.newDistribution.savedTemplates'"
                >
                    <agpr-list-filter-select
                        [id]="id + '_savedTemplates'"
                        class="agpr-newDistribution-existingDistributions agpr-newDistribution-savedTemplates"
                        [list]="savedTemplates"
                        placeholder="Discover.distribution.newDistribution.createFromTemplate.filterTextInput.placeholder"
                        textInputAriaLabel="Discover.distribution.newDistribution.createFromTemplate.filterTextInput.placeholder"
                        listAriaLabel="Discover.distribution.newDistribution.createFromTemplate.listAriaLabel"
                        [vsMinBufferPx]="560"
                        [vsMaxBufferPx]="1050"
                        [showActionButton]="true"
                        actionButtonTooltip="Discover.distribution.manageTemplate"
                        (itemSelected)="onRowSelect($event)"
                        (actionButtonClicked)="openManageTemplateDialog()"
                    ></agpr-list-filter-select>
                </agpr-tab>
                <agpr-tab
                    noScrollPanelContent
                    [id]="id + '_fromPreviousTab'"
                    [icon]="'fa-regular fa-duotone fa-clock-rotate-left'"
                    [heading]="'Discover.distribution.newDistribution.pastDistributions'"
                >
                    <agpr-list-filter-select
                        [id]="id + '_pastDistributions'"
                        class="agpr-newDistribution-existingDistributions"
                        [list]="filteredDistributions"
                        textInputLabel="Discover.distribution.newDistribution.createFromPrevious.heading"
                        placeholder="Discover.distribution.newDistribution.createFromPrevious.filterTextInput.placeholder"
                        textInputAriaLabel="Discover.distribution.newDistribution.createFromPrevious.filterTextInput.placeholder"
                        listAriaLabel="Discover.distribution.newDistribution.createFromPrevious.listAriaLabel"
                        [vsMinBufferPx]="560"
                        [vsMaxBufferPx]="1050"
                        (itemSelected)="onRowSelect($event)"
                    ></agpr-list-filter-select>
                </agpr-tab>
            </agpr-tabs>
        </div>
        @if (openAiPermission && selectedTabIndex === newDistributionTabs.defaultTemplate) {
            <agpr-copilot-switch-banner
                [description]="'Discover.distribution.newAiDistribution.template.openAiDescription' | localize"
                [skipCoverageInsights]="true"
                [(ngModel)]="enableCoPilot"
            ></agpr-copilot-switch-banner>
        }
        <agpr-action-bar class="agpr-newDistribution-actionBar">
            <ng-template #right>
                <agpr-button
                    [id]="id + '_createDistribution'"
                    [disabled]="(!selectedDistribution && !selectedTemplate) || !canCreateDistribution"
                    (click)="createDistribution()"
                    [style]="buttonTypes.primary"
                    [tooltip]="((!selectedDistribution && !selectedTemplate) || !canCreateDistribution) ? 'Discover.distribution.newDistribution.createButton.disabledTooltip' : null"
                    label="Discover.distribution.newDistribution.createButton"
                ></agpr-button>
            </ng-template>
        </agpr-action-bar>
    </div>
</section>
